import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@shared/material.module';

import { PageContainerComponent } from './components/page-container/page-container.component';

@NgModule({
  declarations: [PageContainerComponent],
  imports: [CommonModule, RouterModule, MaterialModule],
})
export class LayoutModule {}
